// extracted by mini-css-extract-plugin
export default {"btnHolder":"ContractView_btnHolder__LEvtD"};